exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".feedback-button {\n  position: relative;\n}\n.feedback-button .active-feedback {\n  right: 3px;\n  top: 5px;\n  margin: auto;\n  transition: color 0.5s ease-in-out, opacity 0.5s ease-in-out;\n  transition-delay: 0.3s;\n  height: 100%;\n  color: rgba(0,196,45,0);\n  position: absolute;\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n  align-items: center;\n  border-radius: 50%;\n  height: 25px;\n  width: 25px;\n  background-color: #fff;\n  opacity: 0;\n  padding-bottom: 3px;\n  border: 1px solid #eee;\n  box-shadow: 0px 1px 5px 0px rgba(0,0,0,0.61);\n}\n.feedback-button:active .active-feedback,\n.feedback-button.active .active-feedback {\n  color: #00c42d;\n  transition-delay: 0;\n  transition-property: none;\n  opacity: 1;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/stylus-loader!./frontend/olos/styles/FeedbackButton.styl
// module id = 1895
// module chunks = 1